import React, { useContext } from "react";
import MyContext from "../../context/data/myContext";
import { Link } from "react-router-dom";

function UpdateFact() {
  const context = useContext(MyContext);
  const { fac, setFact, updateFactura } = context;

  const handleUpdateFactura = async () => {
    await setFact((prevFac) => ({ ...prevFac, process: "FACTURADO" }));
    if (fac.process === "FACTURADO") {
      // Only allow the update if the process is "FACTURADO"
      if (updateFactura && typeof updateFactura === "function") {
        try {
          await updateFactura();
          console.log("Factura updated successfully.");
        } catch (error) {
          console.error("Error updating factura:", error);
        }
      }
    }
  };

  return (
    <div className="p-0 sm:p-6">
      <div className=" mx-auto max-w-sm px-6 py-6 bg-gray-50 border-2 shadow-lg">
        <h1 className="text-center text-xl mb-4">POST FILE</h1>
        <h1 className="text-center  text-xs mb-4">Nota: Doble Click</h1>
        <div className="flex flex-col mb-3">
          <input
            type="text"
            value={fac.factura}
            onChange={(e) => setFact({ ...fac, factura: e.target.value })}
            name="fac"
            className="mx-auto px-4 py-2 border focus:ring-gray-500 focus:border-gray-900 w-full sm:text-sm border-gray-300 rounded-md focus:outline-none text-gray-600"
            placeholder="Factura"
            style={{ width: "90%" }}
          />
        </div>

        <div className=" flex justify-center mb-3">
          <Link
            to="../delivery"
            className="bg-cl1  hover:bg-cl2 text-white font-bold py-2.5 px-4  rounded m-2"
          >
            Regresar
          </Link>
          <button
            onClick={handleUpdateFactura}
            className="bg-cl1  hover:bg-cl2 text-white font-bold py-2 px-4 rounded m-2"
          >
            Actualizar
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateFact;
